import React from "react";
import ResourceTable from "../components/ResourceTable/ResourceTable";
import { Button } from "antd";
import { useNavigate } from "react-router-dom";
import { useTitle } from "../hooks/useTitle";
import { useTranslation } from "react-i18next";

const ResourcePage = () => {
  const { t } = useTranslation();

  useTitle(t("page-title.resources"));
  const navigate = useNavigate();

  return (
    <div
      style={{
        width: "100%",
        maxWidth: 1000,
        display: "flex",
        flexDirection: "column",
        justifyContent: "center",
        alignItems: "flex-end",
        marginTop: "2.5rem",
      }}
    >
      <Button
        onClick={() => navigate("/portal/add-resource")}
        style={{ paddingInline: "1.2rem", marginBottom: "0.5rem" }}
      >
        {t("pages.resources.add-resource")}
      </Button>
      <ResourceTable />
    </div>
  );
};

export default ResourcePage;
